<template>
    <table class="table table-bordered table-striped table-vcenter dataTable">
        <thead>
            <tr>
                <th>Name</th>
                <th>Open Jobs Count</th>
                <th></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        ajaxUrl: String,
    },

    mounted() {
        let table = window.jQuery(this.$el).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'desc']],
            columns: [
                {
                    data: 'both_names',
                },
                {
                    data: 'jobs_count',
                },
                {
                    data: 'actions',
                },
                { data: 'name', visible: false },
                { data: 'display_name', visible: false },
            ]
        });

        Eventbus.on('staff-table-refresh', () => {
            table.ajax.reload(null, false);
        });
    }
}
</script>
